import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Loader } from 'src/components/atoms/Loader';
import { configVars } from 'src/helpers';

const IdentityVerificationReportPage: React.FC = () => {
  const { identityVerificationId } = useParams();

  useEffect(() => {
    if (identityVerificationId) {
      window.location.replace(
        `${configVars.epa_url}/identity/applicants/${identityVerificationId}/report?format=html&preset=summary-and-documents`
      );
    }
  }, [identityVerificationId]);

  return <Loader isFixed />;
};

export default IdentityVerificationReportPage;
